// extracted by mini-css-extract-plugin
export var container = "_3s-0";
export var disabled = "_3s-4";
export var fullWidth = "_3s-3";
export var lined = "_3s-1";
export var selected = "_3s-5";
export var tab = "_3s-2";